export function getStatusText(Status: number): string {
  switch (Status) {
    case 1:
      return "NEW";
    case 2:
      return "REVIEWING";
    case 3:
      return "DEVELOPING";
    case 4:
      return "COMPLETED";
    case 5:
      return "CLOSED";
    case 6:
      return "ON HOLD";
    default:
      return "NEW";
  }
}
